import React, {
  createContext,
  useReducer,
  useEffect,
  useContext,
  useRef,
} from 'react'
import { Storage } from '../../utils.jsx'
import { useGameMode } from '../GameModes/GameModes.jsx'

export const GameStatsContext = createContext()

const initialState = {
  isInitialized: false,
  losses: 0,
  streak: 0, 
  longestStreak: 0, 
  gamesPlayed: 0, 
  topScores: 0,
  worstChain: 0,
  avgDistanceFromBest: 0, 
  avgDistanceFromAvg: 0, 
}

function statsReducer(state, action) {
  switch (action.type) {
    case 'INITIALIZE_STATS':
      console.debug('Initializing stats:', action.payload)
      return {
        ...initialState,
        wordLength: action.payload.wordLength,
      }

    case 'INIT_STATS_COMPLETED':
      console.debug("Stats - setting 'isInitialized' to true")
      return {
        ...state,
        isInitialized: true,
      }

    case 'LOAD_STATS':
      console.debug('Loading stats:', action.payload)
      return { ...initialState, ...action.payload }

    case 'LOSS_UP':
      console.debug('Incrementing losses and resetting streak')
      return {
        ...state,
        losses: state.losses + 1,
        streak: 0,
      }

    case 'STREAK_DOWN':
      console.debug('Resetting streak')
      return {
        ...state,
        streak: 0,
      }

    case 'STREAK_UP':
      console.debug('Incrementing streak')
      const updatedStats = streakUp(state, action.payload)
      return {
        ...state,
        ...updatedStats,
      }

    default:
      return state
  }
}

const loadInitialState = (gameMode, dispatch) => {
  const savedStats = Storage.getGameStats(gameMode)
  if (savedStats) {
    console.debug('Loading saved stats:', savedStats)
    dispatch({ type: 'LOAD_STATS', payload: savedStats })
  } else {
    console.debug('Initializing stats')
    dispatch({
      type: 'INITIALIZE_STATS',
      payload: { wordLength: gameMode.slice(-1) },
    })
  }
  dispatch({ type: 'INIT_STATS_COMPLETED' })
}

function streakUp(currentState, scoreInfo) {
  const updatedStreak = currentState.streak + 1
  const isLongestStreak = updatedStreak > currentState.longestStreak
  const gamesPlayed = currentState.gamesPlayed + 1
  const topScores =
    (currentState.topScores ?? 0) +
    (scoreInfo.score === scoreInfo.bestScore ? 1 : 0)
  const worstChain = Math.max(currentState.worstChain ?? 0, scoreInfo.score)

  const avgDistanceFromBest =
    (currentState.gamesPlayed * currentState.avgDistanceFromBest +
      (scoreInfo.score - scoreInfo.bestScore)) /
    gamesPlayed

  const avgDistanceFromAvg =
    (currentState.gamesPlayed * currentState.avgDistanceFromAvg +
      (scoreInfo.score - scoreInfo.avgScore)) /
    gamesPlayed

  console.log(scoreInfo.bestScore)
  console.log('avgDistanceFromAvg:', avgDistanceFromAvg)

  return {
    streak: updatedStreak,
    longestStreak: isLongestStreak ? updatedStreak : currentState.longestStreak,
    gamesPlayed: gamesPlayed,
    topScores,
    worstChain,
    avgDistanceFromBest: avgDistanceFromBest,
    avgDistanceFromAvg: avgDistanceFromAvg,
  }
}

export const GameStatsProvider = ({ children }) => {
  const { gameMode } = useGameMode()
  const [state, dispatch] = useReducer(statsReducer, initialState)

  useEffect(() => {
    loadInitialState(gameMode, dispatch)
  }, [gameMode])

  useEffect(() => {
    const statsToSave = {
      losses: state.losses,
      streak: state.streak,
      longestStreak: state.longestStreak,
      gamesPlayed: state.gamesPlayed,
      topScores: state.topScores,
      worstChain: state.worstChain,
      avgDistanceFromBest: state.avgDistanceFromBest,
      avgDistanceFromAvg: state.avgDistanceFromAvg,
    }

    Storage.saveGameStats(gameMode, statsToSave)
  }, [state, gameMode])

  return (
    <GameStatsContext.Provider value={{ state, dispatch }}>
      {children}
    </GameStatsContext.Provider>
  )
}
